import { FaArrowUp, FaGlobe } from 'react-icons/fa';
import AppDemoPreview from './AppDemoPreview';
import styles from './AppDemoCard.module.css';

function AppDemoCard({ demo, index }) {
  const domain = new URL(demo.url).hostname.replace(/^www\./, '');

  return (
    <article className={styles.card} aria-labelledby={`${demo.id}-title`}>
      <div className={styles.cardTop}>
        <span className={styles.number} aria-hidden="true">
          {String(index + 1).padStart(2, '0')}
        </span>
        <span className={`${styles.status} ${styles[demo.statusKey]}`}>
          <span className={styles.statusDot} aria-hidden="true" />
          {demo.status}
        </span>
      </div>

      <AppDemoPreview demo={demo} />

      <div className={styles.identity}>
        <span className={styles.appIcon} aria-hidden="true"><FaGlobe /></span>
        <p className={styles.category}>{demo.category}</p>
      </div>
      <h3 id={`${demo.id}-title`} className={styles.title}>{demo.title}</h3>
      <p className={styles.description}>{demo.description}</p>

      <div className={styles.footer}>
        <p className={styles.domain}>{domain}</p>
        <a
          href={demo.url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.demoLink}
          aria-label={`Explore ${demo.title} (opens in a new tab)`}
        >
          Explore app
          <FaArrowUp className={styles.arrow} aria-hidden="true" />
        </a>
      </div>
    </article>
  );
}

export default AppDemoCard;
